import {NgModule}                       from '@angular/core';
import {
  BodyModule,
  FilterMenuModule,
  GridModule,
  GroupModule,
  HeaderModule,
  PagerModule,
  RowFilterModule
}                                       from '@progress/kendo-angular-grid';
import {CommonModule}                   from '@angular/common';
import {ApTranslationModule}            from '../translation/ap-translation.module';
import {
  ButtonModule,
  DropDownButtonModule,
  SplitButtonModule
}                                       from '@progress/kendo-angular-buttons';
import {
  ComboBoxModule,
  DropDownsModule
}                                       from '@progress/kendo-angular-dropdowns';
import {
  FormsModule,
  ReactiveFormsModule
}                                       from '@angular/forms';
import {ApCoreModule}                   from '../ap-core/ap-core.module';
import {ApTranslationsComponent}        from './components/translations/ap-translations.component';
import {ApAdministrationRoutes}         from './ap-administration.routes';
import {DateInputsModule}               from '@progress/kendo-angular-dateinputs';
import {ApDynformsModule}               from '../ap-dynforms/ap-dynforms.module';
import {LayoutModule}                   from '@progress/kendo-angular-layout';
import {ApUtilsModule}                  from '../ap-utils';
import {ApKrigingComponent}             from './components/kriging/ap-kriging.component';
import {ApGridStyleComponent}           from './components/grid-style/ap-grid-style.component';
import {ApFormStyleComponent}           from './components/form-style/ap-form-style.component';
import {ApDynGridsModule}               from '../ap-dyngrids/ap-dyngrids.module';
import {ApDynComponentModule}           from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApTooltipModule}                from '../ap-tooltip/ap-tooltip.module';
import {ApResponsiveTextModule}         from '../ap-responsive-text/ap-responsive-text.module';
import {ApSectionHeaderModule}          from '../ap-section-header/ap-section-header.module';
import {ApJobsComponent}                from './components/jobs/ap-jobs.component';
import {ApStatusSwitchModule}           from '../ap-status-switch/ap-status-switch.module';
import {ApPermissionModule}             from '../ap-permission/ap-permission.module';
import {ApParameterDefinitionComponent} from './components/parameter/ap-parameter-definition.component';
import {ApTraceLogActionsComponent}     from './components/tracelog/ap-trace-log-actions.component';
import {ApTraceLogBackendComponent}     from './components/tracelog/ap-trace-log-backend.component';
import {ApTraceLogClientComponent}      from './components/tracelog/ap-trace-log-client.component';
import {ApTraceLogComponent}            from './components/tracelog/ap-trace-log.component';
import {ApActiveUsersComponent}         from './components/active-users/ap-active-users.component';


@NgModule({
  declarations: [
    ApTranslationsComponent,
    ApKrigingComponent,
    ApGridStyleComponent,
    ApFormStyleComponent,
    ApJobsComponent,
    ApParameterDefinitionComponent,
    ApTraceLogActionsComponent,
    ApTraceLogBackendComponent,
    ApTraceLogClientComponent,
    ApTraceLogComponent,
    ApActiveUsersComponent,
  ],
  exports: [
    ApTranslationsComponent,
    ApKrigingComponent,
    ApGridStyleComponent,
    ApFormStyleComponent,
    ApJobsComponent,
    ApParameterDefinitionComponent,
    ApTraceLogActionsComponent,
    ApTraceLogBackendComponent,
    ApTraceLogClientComponent,
    ApTraceLogComponent,
    ApActiveUsersComponent,
  ],
  imports: [
    ReactiveFormsModule,
    SplitButtonModule,
    ComboBoxModule,
    DateInputsModule,
    GridModule,
    ApCoreModule,
    ApTranslationModule,
    ApUtilsModule,
    CommonModule,
    ButtonModule,
    FormsModule,
    DropDownsModule,
    DropDownButtonModule,
    ApDynformsModule,
    LayoutModule,
    ApUtilsModule,
    RowFilterModule,
    ApAdministrationRoutes,
    HeaderModule,
    BodyModule,
    PagerModule,
    FilterMenuModule,
    ApDynGridsModule,
    ApDynComponentModule,
    ApTooltipModule,
    ApResponsiveTextModule,
    GroupModule,
    ApSectionHeaderModule,
    ApStatusSwitchModule,
    ApPermissionModule
  ]
})
export class ApAdministrationModule {
}
